export default __webpack_public_path__ + "static/media/serving-dish.d10870b4.png";